'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { EducationalPost, EducationalPostsResponse } from '@insta-club/models';
import { EducationalPostItem } from 'src/libs/components/common';
import ContentWrapper from 'src/libs/components/common/contentWrapper';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSWR from 'swr';

function LatestAcademyVideo() {
    const { isLoading, data } = useSWR<EducationalPostsResponse>(ApiKeys.GET_EDUCATIONAL_POSTS, (url: string) =>
        fetcher(url, 'dashboard', 'GET')
    );

    return (
        <>
            {isLoading ? (
                <ContentWrapper
                    title='جدیدترین ویدیو آکادمی'
                    link={{
                        title: 'نمایش همه',
                        href: '/videos'
                    }}
                >
                    <Swiper slidesPerView={'auto'} spaceBetween={24} slidesOffsetBefore={24} slidesOffsetAfter={24}>
                        {Array.from({ length: 10 }, (_, index) => {
                            return (
                                <SwiperSlide key={index} style={{ width: 202, height: 313 }}>
                                    <div className='mr-[24px]'>
                                        <div className='animate-pulse'>
                                            <div className='relative overflow-hidden rounded-2xl'>
                                                <div className='relative aspect-[4/3] h-[250px] w-full bg-gray-200' />
                                                <div className='absolute inset-0 z-[1] flex items-center justify-center bg-gradient-to-b from-transparent via-transparent to-black/60'>
                                                    <div className='h-14 w-14 rounded-full bg-gray-300' />
                                                </div>
                                            </div>
                                            <div className='mt-2 space-y-2'>
                                                <div className='h-4 w-3/4 rounded bg-gray-300' />

                                                <div className='mt-2 flex items-center'>
                                                    <div className='ml-1 h-7 w-7 rounded-full bg-gray-300' />
                                                    <div className='h-3 w-1/2 rounded bg-gray-300' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </ContentWrapper>
            ) : (
                !!data?.data.length && (
                    <ContentWrapper
                        title='جدیدترین ویدیو آکادمی'
                        link={{
                            title: 'نمایش همه',
                            href: '/videos'
                        }}
                    >
                        <Swiper slidesPerView={'auto'} spaceBetween={24} slidesOffsetBefore={24} slidesOffsetAfter={24}>
                            {data?.data?.map((item: EducationalPost) => {
                                return (
                                    <SwiperSlide key={item.title} style={{ width: 202, height: 313 }}>
                                        <EducationalPostItem item={item} />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </ContentWrapper>
                )
            )}
        </>
    );
}

export default LatestAcademyVideo;

